import { z } from "zod";

import { zFromToSchema } from "./from-to";
import { zGenderSchema } from "./gender";
import { zPayment } from "./payment";
import { zReferralInfoSchema } from "./referral-info";
import { zStatusSchema } from "./status";

import { ServiceEntity } from "~/entities/service/@x/order";
import { UserEntity } from "~/entities/user/@x/order";
import { zEmptyString, zQuantity } from "~/shared/zod";

const zSchema = z.object({
  id: z.string().uuid(),
  number: z.number().int(),
  from: zFromToSchema,
  to: zFromToSchema,
  cargoDescription: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 10),
  referralInfo: zReferralInfoSchema,
  contactPerson: z.object({
    fullName: z
      .string()
      .trim()
      .nonempty()
      .max(2 ** 7),
    email: z.union([zEmptyString, UserEntity.zSchema.shape.email]),
    phone: UserEntity.zSchema.shape.phone,
    gender: zGenderSchema,
  }),
  status: zStatusSchema,
  payment: zPayment,
  cost: z.number().nonnegative(),
  moveIsScheduledFor: z.date(),
  services: z.array(
    ServiceEntity.zSchema
      .pick({
        id: true,
        name: true,
        price: true,
      })
      .extend({
        quantity: zQuantity,
      }),
  ),
  createdAt: z.date(),
});
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
